import { render, staticRenderFns } from "./NewProjectForm.vue?vue&type=template&id=ed7f2412"
import script from "./NewProjectForm.vue?vue&type=script&lang=js"
export * from "./NewProjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports